import * as actionTypes from "../ActionTypes";
import API from "../../network/redAPI";

export const getAllNotifications = (data, dispatch) => {
	dispatch({
		type: actionTypes.NOTIFICATIONS_LOADING_ENABLE,
	});
	API.GetNotifications(data)
		.then((response) => response.json())
		.then((data) => {
			if (data.success) {
				if (data.data.length >= 1) {
					dispatch({
						type: actionTypes.NOTIFICATIONS,
						payload: data.data,
					});
				} else {
					dispatch({
						type: actionTypes.NOTIFICATIONS_HAS_MORE,
						payload: false,
					});
				}
			}
			dispatch({
				type: actionTypes.NOTIFICATIONS_LOADING_DISABLE,
			});
		});
};

export const getCountUnreadNotifications = (dispatch) => {
	API.GetCountUnreadNotifications()
		.then((response) => response.json())
		.then((data) => {
			if (data.success) {
				dispatch({
					type: actionTypes.UNREAD_NOTIFICATIONS,
					payload: data.data,
				});
			}
		});
};
export const markAllAsRead = (dispatch) => {
	dispatch({
		type: actionTypes.NOTIFICATIONS_LOADING_ENABLE,
	});
	API.markAllNotifications()
		.then((response) => response.json())
		.then((data) => {
			if (data.success) {
				dispatch({
					type: actionTypes.RESET_NOTIFICATIONS_PAGE,
				});
				dispatch({
					type: actionTypes.UNREAD_NOTIFICATIONS,
					payload: 0,
				});
				dispatch({
					type: actionTypes.NOTIFICATIONS,
					payload: [],
				});
			}
		});
};
export const changeNotificationPage = (body, dispatch) => {
	console.log(actionTypes.CHANGE_NOTIFICATIONS_PAGE);
	dispatch({
		type: actionTypes.CHANGE_NOTIFICATIONS_PAGE,
		payload: body.page,
	});
};

export const resetNotificationPage = (dispatch) => {
	dispatch({
		type: actionTypes.RESET_NOTIFICATIONS_PAGE,
	});
};
